import type { SaleTransaction } from '@/types/farmsales'
import { api } from '@/api/auth'
import type { PaginatedResponse } from '@/types/api'

const API_URL = 'farm/sales/'

export default {
  async list(): Promise<SaleTransaction[]> {
    const { data } = await api.get<PaginatedResponse<SaleTransaction>>(API_URL)
    return data.results
  },
  async create(payload: Partial<SaleTransaction>) {
    return api.post(API_URL, payload)
  },
  async update(id: string, payload: Partial<SaleTransaction>) {
    return api.put(`${API_URL}${id}/`, payload)
  },
  async delete(id: string) {
    return api.delete(`${API_URL}${id}/`)
  },
}
